import { useState } from "react";

import { Box, Typography } from "@mui/material";

import { ProductFilterBox } from "./ProductFilterBox";
import { FixedPanel } from "../../../components/FixedPanel";
import { ProductRef } from "../../../features/products/product";
import { ProductFilter } from "../../../features/products/product-func";
import { ListAction, ProductList } from "./ProductList";
import { productDbAtom } from "../../../features/products/product.state";
import { useAtom } from "jotai";

type ProductPanelProps = {
  actions?: ListAction[];
  fields?: string[];
  onClick?: (ref: ProductRef) => void;
  onAction?: (action: ListAction, ids: string[]) => void;
  hint: string;
  emptyState?: React.ReactNode;
  /**
   * Fill the parent instead of sizing off the window. FixedPanel measures
   * `window.innerHeight - top`, which overshoots inside a nested scrolling
   * container and leaves the list with two scrollbars.
   */
  fill?: boolean;
};

export const ProductPanel = ({
  actions,
  fields,
  onClick,
  onAction,
  hint,
  emptyState,
  fill,
}: ProductPanelProps) => {
  const [filter, setFilter] = useState<ProductFilter>({});
  const [productDb] = useAtom(productDbAtom);

  const list = (
    <ProductList
      actions={actions}
      fields={fields}
      filter={filter}
      onClick={onClick}
      onAction={onAction}
      emptyState={emptyState}
    />
  );

  return (
    <Box
      sx={
        fill
          ? {
              height: "100%",
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }
          : { height: "100%" }
      }
    >
      {productDb.productMap.size > 0 && (
        <ProductFilterBox filter={filter} setFilter={setFilter} />
      )}
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ px: 1, mb: 1 }}
      >
        {hint}
      </Typography>
      {fill ? (
        <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>{list}</Box>
      ) : (
        <FixedPanel breakpoint="lg">{list}</FixedPanel>
      )}
    </Box>
  );
};
